import { Bluetooth, BluetoothSearching, Loader2, RefreshCw } from "lucide-react";

const STYLES = {
  connected: { label: "Connected", dot: "bg-[hsl(var(--success))]", icon: Bluetooth },
  connecting: { label: "Connecting…", dot: "bg-accent dark:bg-primary blink", icon: Loader2, spin: true },
  reconnecting: { label: "Reconnecting…", dot: "bg-accent blink", icon: RefreshCw, spin: true },
  disconnected: { label: "No hub", dot: "bg-muted-foreground/50", icon: BluetoothSearching },
};

export const HubStatusBadge = ({ status, name, attempt }) => {
  const s = STYLES[status] || STYLES.disconnected;
  const Icon = s.icon;
  return (
    <span
      data-testid="hub-status-badge"
      data-status={status}
      className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1.5 text-xs font-semibold"
    >
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      <Icon className={`h-3.5 w-3.5 text-muted-foreground ${s.spin ? "animate-spin" : ""}`} />
      <span className="max-w-[140px] truncate">
        {status === "connected" ? name : s.label}
        {status === "reconnecting" && attempt ? ` (${attempt})` : ""}
      </span>
    </span>
  );
};
